// ABOUTME: Hook determining availability of Plus Load and Close At shortcut buttons.
// Both buttons share the same conditions: feature flag + order changeable + quantityChangeExpected
// on the schedule + lifecycle after last truck loaded (isPlusLoadEnabled).

import {isPlusLoadEnabled} from '@hconnect/tuc-processes/orderManagement/orderChange/plusLoad/isPlusLoadEnabled'
import {useMemo} from 'react'

import {useFeaturesState} from '../../../../Organisms/Features'
import {Order} from '../../../../Pages/Order/Order.types'
import {mapHubOrderToOrderDto} from '../utils/mapHubOrderToOrderDto'

export const usePlusLoadAvailability = (order?: Order): boolean => {
  const {getFeature} = useFeaturesState()
  const isOrderManagementEnabled = getFeature('OrderManagementRMCHub')

  return useMemo(() => {
    if (!order || !isOrderManagementEnabled) return false
    if (!(order.orderManagement?.isChangeable ?? false)) return false
    if (order.schedules?.[0]?.quantityChangeExpected !== true) return false

    return isPlusLoadEnabled(mapHubOrderToOrderDto(order))
  }, [order, isOrderManagementEnabled])
}
